export const frameToData = (frame: number, data: any[]) => {
  const dataLength = data.length;
  const frameIndex = frame % dataLength;
  return data[frameIndex];
};
